import type { IBuzzbridgeLoyaltyConfig } from '../types/global/buzzbridgeLoyalty.types';

export const DEFAULT_BUZZBRIDGE_LOYALTY: IBuzzbridgeLoyaltyConfig = {
    enabled: true,
    referral_signup_points: 100,
    referral_subscribe_points: 50,
    subscription_commission: {
        enabled: true,
        percentage: 5,
        cap_usd_cents: 500,
        window_months: 6,
        in_perpetuity: false,
    },
    job_service_fee_commission: {
        enabled: true,
        share_of_platform_fee_percentage: 15,
        requires_referee_not_subscribed: true,
    },
    redemption_programs: [
        {
            id: 'amazon_gift_card',
            label: 'Amazon Gift Cards',
            points_required: 5000,
            fulfillment_type: 'email_voucher',
            active: true,
        },
        {
            id: 'paypal_cashout',
            label: 'PayPal Cashout',
            points_required: 10000,
            fulfillment_type: 'paypal',
            active: true,
        },
        {
            id: 'brand_credit',
            label: 'Brand Credit',
            points_required: 2500,
            fulfillment_type: 'brand_credit',
            active: true,
        },
        {
            id: 'premium_subscription',
            label: 'Premium Subscription',
            points_required: 15000,
            fulfillment_type: 'subscription',
            active: true,
        },
        {
            id: 'exclusive_merchandise',
            label: 'Exclusive Merchandise',
            points_required: 20000,
            fulfillment_type: 'merchandise',
            active: true,
        },
    ],
    agreement_pdf_url: '',
    min_withdrawal_usd_cents: 4000,
};
